import { useState, useMemo } from 'react';
import { Alert, Divider, Input, Typography } from 'antd';
import { RevealingLink } from 'components/ui/RevealingLink/RevealingLink';
import { CHILD_CYS_LINKS } from '../constants';

export function ChildCysRevealingLink() {
  const [searchTerm, setSearchTerm] = useState('');

  // Filter links based on search term
  const filteredLinks = useMemo(() => {
    if (!searchTerm.trim()) return CHILD_CYS_LINKS;
    const lowerSearch = searchTerm.toLowerCase();
    return CHILD_CYS_LINKS.filter((link) => link.name.toLowerCase().includes(lowerSearch));
  }, [searchTerm]);

  return (
    <RevealingLink
      text="View which bases require the SNA"
      expandedText="Hide which bases require the SNA"
      reveals={
        <Alert
          type="info"
          showIcon
          message="Army Installations"
          description={
            <>
              <p className="mb-4">To verify if you need the installation and map to your home address</p>

              <Input
                placeholder="Search for a base (e.g., Fort Knox, Miami)..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                allowClear
                className="mb-3"
              />

              <Typography.Text type="secondary" className="block my-4">
                Showing {filteredLinks.length} of {CHILD_CYS_LINKS.length} bases
              </Typography.Text>

              {filteredLinks.length !== 0 && <Divider />}

              <ul className="gap-4 list-disc pl-4 m-0 grid grid-flow-col auto-rows-max grid-cols-1 grid-rows-[repeat(36,auto)] md:grid-cols-2 md:grid-rows-[repeat(18,auto)] lg:grid-cols-3 lg:grid-rows-[repeat(12,auto)]">
                {filteredLinks.map((link) => (
                  <li key={link.name}>
                    <a href={link.link} target="_blank" rel="noreferrer" className="!underline">
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </>
          }
        />
      }
    />
  );
}
